var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H32C38.6274 0 44 5.37258 44 12V32C44 38.6274 38.6274 44 32 44H12C5.37258 44 0 38.6274 0 32V12Z",
    fill: "#D8EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2492 22.7333C30.1032 24.2926 29.5163 25.7782 28.5572 27.0163C27.5981 28.2544 26.3064 29.194 24.8331 29.7251C23.3598 30.2563 21.7657 30.3571 20.2372 30.0158C18.7087 29.6744 17.309 28.9051 16.2015 27.7977C15.0941 26.6903 14.3248 25.2905 13.9835 23.762C13.6421 22.2335 13.743 20.6394 14.2741 19.1661C14.8053 17.6928 15.7448 16.4011 16.9829 15.442C18.221 14.4829 19.7066 13.896 21.2659 13.75C20.3391 14.9857 19.8892 16.5142 19.9987 18.0549C20.1082 19.5956 20.7698 21.0451 21.8619 22.1373C22.9541 23.2295 24.4036 23.891 25.9443 24.0005C27.485 24.11 29.0135 23.6601 30.2492 22.7333Z",
    strokeWidth: 1.74167,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion3);
export default __webpack_public_path__ + "static/media/question 3.81fe151b4426319ce170d0e66063c05a.svg";
export { ForwardRef as ReactComponent };